module.exports = __webpack_public_path__ + "img/wallet-bg.cb277189.png";